var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-list",
    {
      staticClass: "dropdown-list"
    },
    [
      _c(
        "v-list-item",
        [
          _c(
            "v-list-item-content",
            [_c("v-list-item-subtitle", [_vm._v(" No new notifications. ")])],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }